import CardWrapper from '../wrapper/card';
import EmailComponent from '../email';
import EntryDetailsComponent from './entry_details';
import { fetchLeadsThunk } from '../../redux/thunks/lead';
import { KeyboardArrowLeft } from '@mui/icons-material';
import SMSComponent from '../sms';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { a11yProps, CustomTabPanel } from '../../pages/deals';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Tab, Tabs } from '@mui/material';
import { resettingEmailData, settingComposingFlagEmail, settingSelectedEmail } from '../../redux/slices/email';
import { resettingSMSData, settingComposingFlagSMS, settingSelectedSMS } from '../../redux/slices/sms';
import { settingSelectedForm, settingSelectedFormFlag } from '../../redux/slices/form';
import { settingSelectedLead, settingSelectedLeadFlag, settingSelectedLeadTab } from '../../redux/slices/leads';
import { useDispatch, useSelector } from 'react-redux';

const SelectedLeadComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { selectedTab: selectedTabFromState, selectedLeadTab } = useSelector((state: RootState) => state.lead);
    // const [selectedTab, setSelectedTab] = useState<0 | 1 | 2>(0);

    useEffect(() => {
        const fetchLeads = async () => {
            try {
                await dispatch(fetchLeadsThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            } catch (e) {
                //
            }
        };
        fetchLeads();
    }, [id]);

    const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1 | 2) => {
        dispatch(settingSelectedEmail(null));
        dispatch(settingSelectedSMS(null));
        dispatch(settingComposingFlagEmail(false));
        dispatch(settingComposingFlagSMS(false));
        dispatch(settingSelectedLeadTab(newValue));
        // setSelectedTab(newValue);
    };

    const navigateBackHandler = () => {
        if (selectedTabFromState === 0) {
            dispatch(settingSelectedForm(null));
            dispatch(settingSelectedFormFlag(false));
        }
        dispatch(settingSelectedLead(null));
        dispatch(resettingEmailData());
        dispatch(resettingSMSData());
        dispatch(settingSelectedLeadFlag(false));
    };
    return (
        <CardWrapper minHeight="80vh" overflow="auto">
            <Box>
                <Button variant="text" color="secondary" startIcon={<KeyboardArrowLeft />} onClick={navigateBackHandler} >Back</Button>
            </Box>
            <Tabs
                value={selectedLeadTab}
                onChange={handleChange}
                aria-label="Leads details tabs"
            >
                <Tab
                    label="Entry Details"
                    {...a11yProps(0)}
                />
                <Tab
                    label="Email"
                    {...a11yProps(1)}
                />
                <Tab
                    label="SMS"
                    {...a11yProps(2)}
                />
            </Tabs>
            <CardWrapper>
                <CustomTabPanel value={selectedLeadTab} index={0}>
                    <EntryDetailsComponent />
                </CustomTabPanel>

                <CustomTabPanel value={selectedLeadTab} index={1}>
                    <EmailComponent />
                </CustomTabPanel>

                <CustomTabPanel value={selectedLeadTab} index={2}>
                    <SMSComponent />
                </CustomTabPanel>
            </CardWrapper>
        </CardWrapper>
    );
};

export default SelectedLeadComponent;